<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="5">
            <a-form-item label="证书名称">
              <a-input placeholder="请输入证书名称" v-model="where.keyword.name" />
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="证书类型">
              <a-select v-model="where.keyword.type" placeholder="请选择" allowClear>
                <a-select-option value="1">专业课</a-select-option>
                <a-select-option value="2">公需课</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="5">
            <a-form-item label="状态">
              <a-select defaultValue v-model="where.keyword.status">
                <a-select-option value>全部</a-select-option>
                <a-select-option value="0">禁用</a-select-option>
                <a-select-option value="1">启用</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4" :style="{ textAlign: 'left' }">
            <a-button type="primary" @click="searchList" v-btnlimit="'证书设置-搜索'">搜索</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <pxkeji-btn
        name="创建证书"
        class="pxkeji_basic_btn"
        v-btnlimit="'证书设置-创建证书'"
        @click="createCertificate(0,1)"
        type="primary"
      />
      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="type" slot-scope="type">
          <span v-if="type==1">专业课</span>
          <span v-else-if="type==2">公需课</span>
        </span>
        <span slot="status" slot-scope="status">
          <a-tag v-if="status==1" color="green">启用</a-tag>
          <a-tag v-else color="red">禁用</a-tag>
        </span>
        <span slot="trigger" slot-scope="trigger">
          <template v-if="trigger.triggerType==0">学分({{trigger.triggerSetting}})</template>
          <template v-if="trigger.triggerType==1">学时({{trigger.triggerSetting}})</template>
          <template v-if="trigger.triggerType==2">关联课程</template>
          <template v-if="trigger.triggerType==3">关联考试</template>
        </span>
        <span slot="action" slot-scope="action">
          <pxkeji-btn
            name="编辑"
            :roles="[]"
            v-btnlimit="'证书设置-编辑'"
            @click="createCertificate(action.id,2)"
            size="small"
            type="primary"
          />
          <a-divider type="vertical" />
          <pxkeji-btn name="条件设置" size="small" @click="setTrigger(action.id)" type="primary" v-btnlimit="'证书设置-条件设置'"/>
          <a-divider type="vertical" />
          <pxkeji-btn
            name="禁用"
            :roles="[]"
            v-btnlimit="'证书设置-启用禁用'"
            @click="handleProhibit(action.id,0)"
            v-if="action.status==1"
            size="small"
            type="primary"
          />
          <pxkeji-btn
            name="启用"
            :roles="[]"
            v-btnlimit="'证书设置-启用禁用'"
            @click="handleProhibit(action.id,1)"
            v-else
            size="small"
            type="primary"
          />
          <a-divider type="vertical" />
          <pxkeji-btn
            name="删除"
            :roles="[]"
            v-btnlimit="'证书设置-删除'"
            @click="delInfo(action.id)"
            size="small"
            type="primary"
          />
        </span>
      </a-table>
      <div class="totalbox" style="float: left;">
        <div>
          <span>共有：{{list.pagination.total}}条数据</span>
        </div>
      </div>
    </div>

    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      width="1300px"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :id="addedit.id" />
    </a-modal>

    <a-modal
      v-model="triggerModal.triggerShow"
      :footer="false"
      destroyOnClose
      width="70%"
      :maskClosable="false"
      class="ui-modal"
    >
      <trigger @callbackMethod="closeTrigger" :id="triggerModal.id" />
    </a-modal>
  </div>
</template>
<script>
var that;
import Info from "./basicInfo.vue"; //新增编辑
import trigger from "./trigger.vue"; //发证条件设置

const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "序号",
  },
  {
    dataIndex: "name",
    key: "name",
    align: "center",
    title: "证书名称",
  },
  {
    dataIndex: "type",
    key: "type",
    align: "center",
    title: "证书类型",
    scopedSlots: { customRender: "type" },
  },
  {
    dataIndex: "trigger",
    key: "trigger",
    align: "center",
    title: "发证条件",
    scopedSlots: { customRender: "trigger" },
  },
  {
    dataIndex: "createTime",
    key: "createTime",
    align: "center",
    title: "添加时间",
  },
  {
    dataIndex: "weight",
    key: "weight",
    align: "center",
    title: "权重",
  },
  {
    dataIndex: "status",
    key: "status",
    align: "center",
    title: "状态",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "操作",
    key: "action",
    align: "center",
    scopedSlots: { customRender: "action" },
  },
];

export default {
  name: "couponlist",
  data() {
    return {
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10, //页容
        },
      },
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false,
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name: "",
          type: "",
          status: "",
        },
      },
      selectRows: [], //选中项编号
      isloading: false,
      visible: false, //弹框
      triggerModal: {
        triggerShow: false,
        id: 0,
      },
    };
  },
  components: {
    Info: Info,
    trigger,
  },
  mounted: function () {
    this.$nextTick(function () {
      that = this;
      this.GetList();
    });
  },
  watch: {
    selectRows: function () {
      //console.log("watch", val);
    },
  },
  methods: {
    setTrigger(id) {
      this.triggerModal.triggerShow = true;
      this.triggerModal.id = id;
    },
    closeTrigger(flag) {
      this.triggerModal.triggerShow = false;
      if (flag) {
        this.GetList();
      }
    },
    GetList() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.certificate
        .getPageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.where.keyword.type,
          this.where.keyword.name,
          this.where.keyword.status
        )
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    //打开详情
    createCertificate(id, type) {
      if (type == 1) {
        this.addedit.title = "添加";
      } else {
        this.addedit.title = "详情";
      }
      this.addedit.visible = true;
      this.addedit.id = id + "";
      this.addedit.type = type;
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      this.$confirm({
        title: "您确定要执行批量禁用的操作吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.handleProhibit(that.selectRows.join(","), 0);
        },
        onCancel() {},
      });
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      that.isloading = true;
      that.$api.certificate
        .updateStatus(ids, status)
        .then((res) => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.certificate
            .deleteById(id)
            .then((res) => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {},
      });
    },
    save() {
      this.addedit.visible = false;
      this.GetList();
    }, 
  },
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

